export function clearForm(form) {
    $.each(form.elements, function(index, elem){
        if($(elem).is('input') || $(elem).is('select') || $(elem).is('textarea') ||$(elem).is('[class="g-recaptcha"]')){
            if($(elem).attr('type') !== 'hidden'){
                if ($(elem).is(":checkbox") || $(elem).is(":radio")) {
                    $(elem).prop('checked', false);
                }else {
                    $(elem).val('');
                }
            }
        }
    });
}
